import React, { useState } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Tooltip } from '@material-ui/core';
import RichText from '../../../../../utils/RichText';
import { getDefaultIcon } from '../../../../../utils/functions';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import closeButton from '../../../../../components/images/close-button.svg';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';
import { getStepsOptions } from '../../constants/options';
import {
  AdminBannerIcon,
  AdminGameDirectoryIcon,
  AdminGameKeyIcon,
  AdminHashtagIcon,
  AdminCheckboxIcon,
  AdminAchievementIcon,
  AdminClipIcon,
  AdminTextIcon,
  AdminLinkIcon,
  AdminStreamIcon,
  AdminTwitterIcon,
  AdminVerificationIcon,
  AdminBuildStreamIcon
} from '../../../../images/requirement-icons/requirementIcons';
import './Requirements.css';
import MultiVideoSubmissionFields from './MultiVideoSubmissionFields';

const BaseModal = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <section className={`ModalMaster_requirements`}>
      <div onClick={onClose} className="Modal__layer" aria-hidden />
      <section className="Modal__wrapper">
        <img
          alt="close-button"
          className="close"
          src={closeButton}
          onClick={onClose}
        />
        {title && <h2>{title}</h2>}
        {children}
      </section>
    </section>
  );
};

// 抽取工具函数 - 获取要求项状态
const getRequirementState = (req, questForm) => {
  console.log('req', req);
  console.log('questForm', questForm);
  const states = {
    'display-download': {
      banner: {
        condition: !questForm?.values?.requiredBanner,
        message: 'You must upload banner artwork in the \'Details\' section for this requirement to become available.'
      },
      overlay: {
        condition: !questForm?.values?.overlayImage,
        message: 'You must upload overlay artwork in the \'Details\' section for this requirement to become available.'
      }
    },
    'display-hashtags': {
      tracking: {
        condition: !questForm?.values?.trackingTags?.length,
        message: 'You must add tracking hashtags in the \'Parameters\' section for this requirement to become available.'
      },
      quest: {
        condition: !questForm?.values?.questTags?.length,
        message: 'You must add quest hashtags in the \'Parameters\' section for this requirement to become available.'
      }
    },
    'multi-video-submission': {
      tracking: {
        condition: !questForm?.values?.trackingTags?.length,
        message: 'You must add tracking hashtags in the \'Parameters\' section for this requirement to become available.'
      },
    }
  };

  const typeState = states[req.type];
  console.log('typeState', typeState);
  if (!typeState) return { inactive: false, tooltip: '' };

  const subtypeState = typeState[req.subtype];
  console.log('subtypeState', subtypeState);

  if (!subtypeState) return { inactive: false, tooltip: '' };

  return {
    inactive: subtypeState.condition,
    tooltip: subtypeState.condition ? subtypeState.message : ''
  };
};

// 抽取可重用的要求项组件
const RequirementItem = ({ req, inactive, tooltip, onAdd }) => {
  const inactiveClass = classNames({ inactive });

  // 渲染图标的辅助函数
  const getRequirementIcon = (req) => {
    switch (req.value) {
      case 'display-download-banner':
      case 'display-download-overlay':
        return <AdminBannerIcon className={inactiveClass} />;
      case 'display-text-checkbox':
        return <AdminCheckboxIcon className={inactiveClass} />;
      case 'display-text-build-stream':
        return <AdminBuildStreamIcon className={inactiveClass} />;
      case 'display-text-game-name':
        return <AdminGameDirectoryIcon className={inactiveClass} />;
      case 'distribute-key':
        return <AdminGameKeyIcon className={inactiveClass} />;
      case 'display-hashtags-quest':
      case 'display-hashtags-tracking':
        return <AdminHashtagIcon className={inactiveClass} />;
      case 'submit-link-clip':
      case 'submit-link-vod':
      case 'multi-video-submission':
        return <AdminClipIcon className={inactiveClass} />;
      case 'display-text-achievement':
        return <AdminAchievementIcon className={inactiveClass} />;
      case 'submit-tweet':
        return <AdminTwitterIcon className={inactiveClass} />;
      case 'distribute-link-campaign':
      case 'distribute-link-affiliate':
        return <AdminLinkIcon className={inactiveClass} />;
      case 'display-stream-time':
        return <AdminStreamIcon className={inactiveClass} />;
      case 'display-text':
        return <AdminTextIcon className={inactiveClass} />;
      case 'submit-text':
      case 'submit-text-optional':
      default:
        return <AdminVerificationIcon className={inactiveClass} />;
    }
  };

  const content = (
    <div
      className="reqSelect"
      onClick={!inactive ? () => onAdd(req) : null}
    >
      <div className="icon">
        {getRequirementIcon(req)}
      </div>
      <span className={inactiveClass}>{req.label}</span>
    </div>
  );

  return tooltip ? (
    <Tooltip key={req.value} title={tooltip} placement="top">
      {content}
    </Tooltip>
  ) : content;
};
// 优化后的 RequirementModal 组件
const RequirementModal = ({ isOpen, onClose, stepTypeOptions, onAdd, questForm }) => {
  if (!isOpen) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Requirement"
    >
      <div className="reqContainer">
        {stepTypeOptions.map((req) => {
          const { inactive, tooltip } = getRequirementState(req, questForm);
          return (
            <RequirementItem
              key={req.value}
              req={req}
              inactive={inactive}
              tooltip={tooltip}
              onAdd={onAdd}
            />
          );
        })}
      </div>
    </BaseModal>
  );
};


const RequirementControls = ({ index, totalLength, pointInQuest, onSwapRequirement }) => {
  const showUpArrow = index !== 0;
  const showDownArrow = totalLength - 1 !== index;

  return (
    <section className="Step__arrows">
      {showUpArrow && (
        <div
          className="Step__arrow--up"
          onClick={() => onSwapRequirement(pointInQuest, index, 'up')}
          aria-hidden
        >
          <i className="fa fa-arrow-up" />
        </div>
      )}
      {showDownArrow && (
        <div
          className="Step__arrow--down"
          onClick={() => onSwapRequirement(pointInQuest, index, 'down')}
          aria-hidden
        >
          <i className="fa fa-arrow-down" />
        </div>
      )}
    </section>
  );
};

const Requirements = ({ fields, meta: { error, submitFailed }, pointInQuest, questForm, game, onImageUpload, onRichTextUpdate, onAddRequirement, onSwapRequirement }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fieldValues = fields.getAll();

  const stepTypeOptions = getStepsOptions(
    questForm.values?.type === 'affiliate',
    questForm.values?.requirePreapproval
  );


  const getStepReadOnly = (req) => {
    console.log('getStepReadOnly', req);
    if (['display-hashtags', 'display-stream-time','multi-video-submission'].includes(req.type)) {
      return true;
    } else if (req.type === 'display-text' && req.subtype === 'game-name') {
      return true;
    }
    return false;
  };

  


  const handleAddRequirement = (req) => {
    onAddRequirement(fields, req);
    setIsModalOpen(false);
  };
  return (
    <section className="Step">
      <ul>
        {fields.map((step, index) => (
          <li key={index}>
            <section className="Step__header">
              <button
                className="Step__item-remove"
                type="button"
                id={pointInQuest}
                onClick={() => fields.remove(index)}
              >
                Remove requirement
              </button>
              <h4 className="Step__title">Requirement #{index + 1}</h4>
            </section>
            <section className="Step__body">
              <section className="Step__fields">
                {/* Type Display */}
                <div className="Step__row">
                  <div className="input-container" style={{ width: '20%' }}>
                    <label>Requirement Type</label>
                    <span style={{ fontSize: '16px', marginTop: '8px' }}>
                      {stepTypeOptions.find(o =>
                        o.type === fieldValues[index].type &&
                        o.subtype === fieldValues[index].subtype
                      )?.label}
                    </span>
                  </div>

                  {/* Title Input */}
                  <div className="input-container" style={{ width: '75%' }}>
                    <Field
                      name={`${step}.title`}
                      id={`${step}.title`}
                      type="text"
                      component={CustomInput}
                      label="Title"
                      placeholder="Title"
                      readOnly={getStepReadOnly(fields.get(index))}
                      customLabel="Title"
                    />
                  </div>
                </div>

                {/* Icon & Description */}
                <div className="Step__row">
                  <div className="input-container" style={{ width: '25%' }}>
                    <label>Icon</label>
                    {['display-download'].includes(fieldValues[index].type) ? (
                      <img
                        alt="requirement-icon"
                        style={{ objectFit: 'cover', width: '80px', height: '80px' }}
                        src={getDefaultIcon(
                          fieldValues[index].type,
                          fieldValues[index].subtype,
                          questForm.values,
                          game
                        )}
                      />
                    ) : (
                      <div
                        className="QuestEdit__upload"
                        onClick={() => onImageUpload('icon', {
                          pointInQuestIcon: pointInQuest,
                          indexIcon: index
                        })}
                        style={{ cursor: 'pointer' }}
                        aria-hidden
                      >
                        <i className="fa fa-close" style={{
                          color: 'white',
                          position: 'absolute',
                          marginLeft: '70px'
                        }} aria-hidden />
                        <img
                          alt="requirement-icon"
                          style={{ objectFit: 'contain', width: '80px', height: '80px' }}
                          src={fieldValues[index].icon && fieldValues[index].customIcon
                            ? fieldValues[index].icon
                            : getDefaultIcon(
                              fieldValues[index].type,
                              fieldValues[index].subtype,
                              questForm.values,
                              game
                            )
                          }
                        />
                      </div>
                    )}
                  </div>

                  {/* Description Rich Text */}
                  <div className="input-container" style={{ width: '75%' }}>
                    <label>Description</label>
                    <RichText
                      callback={content => onRichTextUpdate(
                        content,
                        `requirements.${pointInQuest}[${index}].description`
                      )}
                      initialValue={fieldValues[index].description}
                    />
                  </div>
                </div>

                {/* Submit Fields */}
                {fieldValues[index].type === 'multi-video-submission' && (
                  <MultiVideoSubmissionFields step={step} />
                )}
                {fieldValues[index].type.includes('submit') && (
                  <div className="Step__row" style={{ width: '75%', marginLeft: '25%' }}>
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.label`}
                        id={`${step}.label`}
                        type="text"
                        component={CustomInput}
                        label="Label"
                        placeholder="Label"
                        customLabel="Label"
                      />
                    </div>
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.placeholder`}
                        id={`${step}.placeholder`}
                        type="text"
                        component={CustomInput}
                        label="Placeholder"
                        placeholder="Placeholder"
                        customLabel="Placeholder"
                      />
                    </div>
                  </div>
                )}

                {/* Tooltip */}
                <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginBottom: '10px' }}>
                  <div className="input-container">
                    <label>Tooltip</label>
                    <RichText
                      callback={content => onRichTextUpdate(
                        content,
                        `requirements.${pointInQuest}[${index}].tooltip`
                      )}
                      initialValue={fieldValues[index].tooltip}
                    />
                  </div>
                </div>

                {/* Show on App Options */}
                <div className="Step__row" style={{ width: '75%', marginLeft: '25%' }}>
                  <div className="input-container" style={{ width: '45%' }}>
                    <Field
                      name={`${step}.showOnApp`}
                      id={`${step}.showOnApp`}
                      component={CustomInputCheckbox}
                      customLabel="Show on Application Page"
                    />
                  </div>
                  {questForm.values?.requirements[pointInQuest][index].showOnApp && (
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.appPageTitle`}
                        id={`${step}.appPageTitle`}
                        component={CustomInput}
                        type="text"
                        label="Application Page Title"
                        customLabel="Application Page Title"
                        placeholder="Application Page Title"
                      />
                    </div>
                  )}
                </div>
              </section>

              {/* Up/Down Arrows */}
              <RequirementControls
                index={index}
                totalLength={fields.length}
                pointInQuest={pointInQuest}
                onSwapRequirement={onSwapRequirement}
              />
            </section>
          </li>
        ))}
      </ul>

      {/* Error Message */}
      {(submitFailed && error) && <span className="Step__error">{error}</span>}

      {/* Add Requirement Button */}
      <button
        className="Step__add-item"
        type="button"
        onClick={() => setIsModalOpen(true)}
      >
        Add Requirement
      </button>

      {/* Requirements Modal */}
      <RequirementModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAdd={handleAddRequirement}
        stepTypeOptions={stepTypeOptions}
        questForm={questForm}
      />
    </section>
  );
};

export default Requirements;